import styled from "styled-components";
import { SlideDown as Slide } from "react-slidedown";
import "react-slidedown/lib/slidedown.css";

export const SlideDown = styled(Slide)`
  overflow-x: hidden;
`;
